export const donateLink = process.env.REACT_APP_DOMAIN_MINI_DONATION_PAGE;
export const storyBoardURL = process.env.REACT_APP_DOMAIN_STORY_BOARD_URL;
